module.exports = "/src/views/player/hudevo/ipad/assets/images/auction.png";